import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";
import { StatusModal } from "components/DesignSystem/StatusModal/StatusModal";

type ResolveRequestModalProps = {
  open: boolean;
  isLoading: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

export const ResolveRequestModal = ({
  open,
  isLoading,
  onCancel,
  onConfirm,
}: ResolveRequestModalProps) => (
  <Modal.Root open={open} onOpenChange={(next) => !next && onCancel()}>
    <Modal.Content useCustomOverlay size="small">
      <StatusModal type="warning" title="Resolve request?">
        This action will mark the changes requested by customer as resolved and
        will send the closing again for review.
      </StatusModal>
      <Modal.FooterButtonGroup>
        <Button
          customType="secondary"
          type="button"
          onClick={onCancel}
          disabled={isLoading}
        >
          Cancel
        </Button>
        <Button
          customType="primary"
          type="button"
          onClick={onConfirm}
          isLoading={isLoading}
          disabled={isLoading}
        >
          Confirm
        </Button>
      </Modal.FooterButtonGroup>
    </Modal.Content>
  </Modal.Root>
);
